import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

const baseUrl = '/secure/policies/dlp/dlp-compliance-rule'

export const purviewDlpComplianceRuleApi = createApi({
  reducerPath: 'purviewDlpComplianceRule',
  tagTypes: ['DlpComplianceRule', 'DlpComplianceRules'],
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getDlpComplianceRules: builder.query({
      query: (customerId) => ({
        url: baseUrl,
        params: { customerId },
      }),
      transformResponse: (response) => response?.filter((rule) => rule?.Mode !== 'PendingDeletion') ?? [],
      providesTags: (result, error, customerId) => [{ type: 'DlpComplianceRules', id: customerId }],
    }),
    getDlpComplianceRulesByPolicy: builder.query({
      query: ({ customerId, policyReferenceId }) => ({
        url: baseUrl,
        params: { customerId, policyReferenceId },
      }),
      providesTags: (result, error, { customerId, policyReferenceId }) => [
        { type: 'DlpComplianceRules', id: customerId },
        { type: 'DlpComplianceRules', id: policyReferenceId },
      ],
    }),
    getDlpComplianceRuleById: builder.query({
      query: ({ customerId, ruleId }) => ({
        url: `${baseUrl}/${ruleId}`,
        params: { customerId },
      }),
      transformResponse: (response) => {
        const { rawDataFlat, ...rest } = response ?? {}
        return { ...rawDataFlat, ...rest }
      },
      providesTags: (result, error, { ruleId }) => [{ type: 'DlpComplianceRule', id: ruleId }],
    }),
  }),
})

export const {
  useGetDlpComplianceRulesQuery,
  useLazyGetDlpComplianceRulesQuery,
  useGetDlpComplianceRulesByPolicyQuery,
  useLazyGetDlpComplianceRulesByPolicyQuery,
  useGetDlpComplianceRuleByIdQuery,
  useLazyGetDlpComplianceRuleByIdQuery,
} = purviewDlpComplianceRuleApi

export const useGetDlpComplianceRules = (options = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetDlpComplianceRulesQuery(customerId, options)
}

export const useGetDlpComplianceRulesByPolicy = ({ policyReferenceId }, options = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetDlpComplianceRulesByPolicyQuery({ customerId, policyReferenceId }, options)
}

export const useGetDlpComplianceRuleById = ({ ruleId }, options = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetDlpComplianceRuleByIdQuery({ customerId, ruleId }, options)
}
